import { render, staticRenderFns } from "./politicaPrivacidadComponent.vue?vue&type=template&id=99274d3c"
import script from "./politicaPrivacidadComponent.vue?vue&type=script&lang=js"
export * from "./politicaPrivacidadComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports